import {Pipe, PipeTransform} from "@angular/core";
import * as moment from 'moment';

@Pipe({
  name: 'timefromnow'
})
export class TimeFromNowPipe implements PipeTransform {

  constructor() {
  }

  pad(num, size?) {
    if (size === void 0) { size = 2; }
    var s = num + '';
    while (s.length < size) {
        s = '0' + s;
    }
    return s;
}

  transform(value: Date, args?: any): any {
    const now = moment();
    const end = moment(value);
    const diff: any = moment.duration(end.diff(now));
    const hours = diff.days() * 24;
    return this.pad(hours + diff.hours()) + ':' + this.pad(diff.minutes()) + ':' + this.pad(diff.seconds());
  }
}
